// userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddVehicleType } from "../../types";

interface AddVehicleState {
  Vehicle: AddVehicleType[];
  smartCarCode: string | null;
  currStep: number | null;
  isVehicleSelected: boolean;
}

const initialState: AddVehicleState = {
  // Vehicle: {
  //   capacity: 0,
  //   carImages: [],
  //   color: "",
  //   createdAt: "",
  //   extraFeatures: [],
  //   insuranceExpDate: "",
  //   insuranceEffectiveDate: "",
  //   insuranceProvider: "",
  //   insuranceProviderNumber: 0,
  //   lessorId: "",
  //   make: "",
  //   millagePerCharge: "",
  //   model: "",
  //   policyNumber: 0,
  //   registrationInfo: "",
  //   seats: 0,
  //   vehicleType: "",
  //   vehicleBrand: "",
  //   year: 0,
  //   vin: "",
  //   location: "",
  // },

  Vehicle: [],
  smartCarCode: null,
  currStep: null,
  isVehicleSelected: false,
};

const addVehicleSlice = createSlice({
  name: "addVehicle",
  initialState,
  reducers: {
    setVehicle: (state, action: PayloadAction<Partial<AddVehicleType>>) => {
      // Update individual properties of the first object
      state.Vehicle[0] = {
        ...state.Vehicle[0],
        ...action.payload,
      };
    },
    clearVehicle: (state) => {
      state.Vehicle = [];
    },
    setSmartCarCode: (state, action: PayloadAction<string>) => {
      state.smartCarCode = action.payload;
    },
    setCurrStep: (state, action: PayloadAction<number>) => {
      state.currStep = action.payload;
    },
    setIsVehicleSelected: (state, action: PayloadAction<boolean>) => {
      state.isVehicleSelected = action.payload;
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
  },
});

export const {
  setVehicle,
  clearVehicle,
  setSmartCarCode,
  setCurrStep,
  setIsVehicleSelected,
} = addVehicleSlice.actions;
export default addVehicleSlice.reducer;
